import React from 'react';
import {HeaderPortal} from '@rocket-ui/components';
import type {FetchVacancyResponse} from '@rocket-ui/lk-api';
import {OfferHeaderActions} from './OfferHeaderActions';
import {OfferHeaderTitle} from './OfferHeaderTitle';

export interface OfferPageHeaderProps {
	vacancy: FetchVacancyResponse;
	title: string;
	price: string;
	isApplying: boolean;
	onApply: (options?: {skipAutoApply?: boolean}) => void;
}

export function OfferPageHeader({
	vacancy,
	title,
	price,
	isApplying,
	onApply,
}: OfferPageHeaderProps): React.ReactElement {
	return (
		<>
			<HeaderPortal position="left">
				<OfferHeaderTitle title={title} price={price} invited={vacancy.invited} applied={vacancy.applied} />
			</HeaderPortal>
			<OfferHeaderActions vacancy={vacancy} isApplying={isApplying} onApply={onApply} />
		</>
	);
}
